import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { List } from 'immutable';
import { generateForm } from '../../form/Form';
import { NodeMessage } from './models';
import { buildBindings } from './helpers';

var dataSources = function dataSources(_ref) {
  var tasks = _ref.tasks,
      tree = _ref.tree,
      node = _ref.node;
  return {
    bindings: {
      fn: buildBindings,
      params: [tree, tasks, node]
    },
    parameters: {
      fn: function fn(node) {
        return node.parameters;
      },
      params: [node]
    }
  };
};

var getOptions = function getOptions(menu) {
  return menu.split(',').filter(function (value) {
    return !!value;
  }).map(function (value) {
    return {
      label: value,
      value: value
    };
  });
};

var checkDependsOn = function checkDependsOn(parameter) {
  return !parameter.dependsOnId || function (_ref2) {
    var values = _ref2.values;
    return values.get("parameter_".concat(parameter.dependsOnId)) === parameter.dependsOnValue;
  };
};

var fields = function fields(_ref3) {
  var tasks = _ref3.tasks,
      tree = _ref3.tree,
      node = _ref3.node;
  return function (_ref4) {
    var bindings = _ref4.bindings;
    return bindings && [{
      name: 'name',
      label: 'Name',
      type: 'text',
      initialValue: node.name,
      required: true,
      constraint: function constraint(_ref5) {
        var values = _ref5.values;
        return tree.nodes.some(function (other) {
          return other.name === values.get('name') && other.id !== node.id;
        }) ? 'This name is already used by another node' : values.get('name').length > 128 ? 'Name cannot exceed 128 characters' : true;
      },
      pattern: /^[^'"]*$/,
      patternMessage: 'Node names may not contain apostrophes or quotes'
    }, {
      name: 'deferrable',
      label: 'Deferrable',
      type: 'checkbox',
      initialValue: node.deferrable,
      visible: false
    }, node.deferrable && {
      name: 'defers',
      label: 'Defers',
      type: 'checkbox',
      initialValue: node.defers
    }, {
      name: 'visible',
      label: 'Visible',
      type: 'checkbox',
      initialValue: node.visible
    }, {
      name: 'definitionId',
      label: 'Task Definition Id',
      type: 'text',
      initialValue: node.definitionId,
      enabled: false
    }, {
      name: 'id',
      label: 'Id',
      type: 'text',
      enabled: false,
      initialValue: node.id
    }].concat(_toConsumableArray(node.parameters.map(function (parameter) {
      return {
        name: "parameter_".concat(parameter.id),
        label: parameter.label,
        type: parameter.menu ? 'select' : 'code',
        language: parameter.menu ? null : 'erb',
        helpText: parameter.description,
        initialValue: parameter.value,
        options: parameter.menu ? getOptions(parameter.menu) : bindings,
        "transient": true,
        visible: checkDependsOn(parameter)
      };
    })), [{
      name: 'parameters',
      type: null,
      visible: false,
      serialize: function serialize(_ref6) {
        var values = _ref6.values;
        return node.parameters.map(function (parameter) {
          return parameter.set('value', values.get("parameter_".concat(parameter.id)));
        });
      }
    }, {
      name: 'message_Create',
      label: 'Create Message',
      type: 'code',
      initialValue: node.messages.filter(function (message) {
        return message.type === 'Create';
      }).map(function (message) {
        return message.value;
      }).first(''),
      language: 'erb',
      options: bindings,
      "transient": true,
      visible: function visible(_ref7) {
        var values = _ref7.values;
        return values.get('defers', false);
      }
    }, {
      name: 'message_Update',
      label: 'Update Message',
      type: 'code',
      initialValue: node.messages.filter(function (message) {
        return message.type === 'Update';
      }).map(function (message) {
        return message.value;
      }).first(''),
      language: 'erb',
      options: bindings,
      "transient": true,
      visible: function visible(_ref8) {
        var values = _ref8.values;
        return values.get('defers', false);
      }
    }, {
      name: 'message_Complete',
      label: 'Complete Message',
      type: 'code',
      initialValue: node.messages.filter(function (message) {
        return message.type === 'Complete';
      }).map(function (message) {
        return message.value;
      }).first(''),
      language: 'erb',
      options: bindings,
      "transient": true
    }, {
      name: 'messages',
      type: null,
      visible: false,
      serialize: function serialize(_ref9) {
        var values = _ref9.values;
        return List(values.get('defers') ? ['Create', 'Update', 'Complete'] : ['Complete']).map(function (type) {
          return NodeMessage({
            type: type,
            value: values.get("message_".concat(type))
          });
        }) // Do not serialize empty messages.
        .filter(function (message) {
          return !!message.value;
        });
      }
    }]);
  };
};

var handleSubmit = function handleSubmit(_ref10) {
  var node = _ref10.node;
  return function (values) {
    return values.toObject();
  };
};

export var NodeForm = generateForm({
  formOptions: ['node', 'tasks', 'tree'],
  dataSources: dataSources,
  fields: fields,
  handleSubmit: handleSubmit
});
NodeForm.displayName = 'NodeForm';